class Form {
    constructor(domElement) {
        if (!Form.instanceMap) {
            Form.instanceMap = new Map();
        }

        Form.instanceMap.set(domElement, this);

        this.domElement = domElement || null;
        this.submitDomElements = this.domElement.querySelectorAll('[type="submit"]');
        this.inputEventTimeout = null;

        this.validator = () => {
            return true;
        };

        this.bindEvents();
        this.bindFormInputEvents();
        this.createObserver();
        this.runValidator();
    }

    bindEvents() {
        this.domElement.addEventListener('submit', this.onSubmit.bind(this));
    }

    bindFormInputEvents() {
        const inputDomElements = [
            ...this.domElement.querySelectorAll('input'),
            ...this.domElement.querySelectorAll('textarea'),
        ];

        for (let i = 0; i < inputDomElements.length; i++) {
            inputDomElements[i].addEventListener('keydown', this.onFormInputEvent.bind(this), {passive: true});
            inputDomElements[i].addEventListener('change', this.onFormInputEvent.bind(this), {passive: true});
        }
    }

    createObserver() {
        const observer = new MutationObserver(this.onDomMutation.bind(this));
        observer.observe(this.domElement, {attributes: true, subtree: true});
    }

    onDomMutation(mutationList, observer) {
        if (mutationList.length === 0) {
            return;
        }

        const target = mutationList[0].target;
        const lowercaseNodeName = mutationList[0].target.nodeName.toLowerCase();
        if (lowercaseNodeName !== 'input' && lowercaseNodeName !== 'select') {
            return;
        }

        if (lowercaseNodeName === 'input') {
            if (target.type === 'submit') {
                return;
            }
        }

        this.runValidator();
    }

    onFormInputEvent() {
        if (!!this.inputEventTimeout) {
            clearTimeout(this.inputEventTimeout);
        }

        this.inputEventTimeout = setTimeout(this.runValidator.bind(this), 100);
    }

    setValidator(validator) {
        this.validator = validator;
        this.runValidator();
    }

    runValidator() {
        const isValid = this.validator(this.getData());

        for (let i = 0; i < this.submitDomElements.length; i++) {
            if (isValid) {
                this.submitDomElements[i].removeAttribute('disabled');
            } else {
                this.submitDomElements[i].setAttribute('disabled', 'disabled');
            }
        }

        return isValid;
    }

    onSubmit(e) {
        const isValid = this.runValidator();

        if (isValid === false) {
            e.preventDefault();
        }
    }

    getData() {
        const formData = new FormData(this.domElement);
        return Object.fromEntries(formData);
    }

    static getInstance(element) {
        if (!Form.instanceMap) {
            return null;
        }

        return Form.instanceMap.get(element);
    }
}

export default Form;
